module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h15"
  }, [_vm._v("ROPED PLAYLIST")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Ludacris—Growing Pains")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Judas Priest—Turbo Lover")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Three Days Grace—Pain")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Greg Holden—The Lost Boy")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Joshua James—Coal War")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Secondhand Serenade—A Twist In My Story")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Anthrax—Madhouse")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Incubus—Drive")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Molly Hatchet—Flirtin’ With Disaster")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Alice Cooper—I’m Eighteen")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Rock Riot—Carry On Wayward Son")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Johnny Cash—Hurt")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Oasis—Wonderwall")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Scorpions—Rock You Like A Hurricane")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Alice Cooper—Poison")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("The Goo Goo Dolls—Iris")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("AC/DC—Highway To Hell")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Mötley Crüe—Shout At The Devil")]), _vm._v(" "), _c('p', {
    staticClass: "p12"
  }, [_vm._v("Five Finger Death Punch—Bad Company")]), _vm._v(" "), _c('p', {
    staticClass: "p14"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b0d06b5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007.vue
// module id = 72
// module chunks = 0